import * as actions from './actions';

export const setDutyPlannerData = (startTime, endTime, groupId, readOnly) => dispatch =>
  dispatch(actions.dutyPlannerDataReceived(startTime, endTime, groupId, readOnly));
